/**
 * Created by Jerker Nord on 2020-06-11.
 */
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    StateReelSymbol
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MonkeysGoldReelSymbol} from "../symbols/MonkeysGoldReelSymbol";

export class MonkeysGoldReelPartCreator extends ReelPartCreator {

    constructor(newSymbolCreator?:(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) => StateReelSymbol) {
        super((symName, reelId, state, size) => {
            return new MonkeysGoldReelSymbol(symName, reelId, state, size);
        });
    }

    deleteSymbol(symbol:StateReelSymbol):void {
        if(symbol.symName.indexOf("colossalx2") > -1 || symbol.symName.indexOf("colossalx3") > -1) {
            (<MonkeysGoldReelSymbol>symbol).resetAnimations();
        }
        super.deleteSymbol(symbol);
    }
}